export default function requireLabSelected({ next, to, store }) {
  const lab = store.getters['session/selectedLaboratory']()

  if (lab && Object.keys(lab).length > 0) {
    return next()
  }

  const labRaw = localStorage.getItem('user_lab_profile')
  if (labRaw) {
    try {
      const parsedLab = JSON.parse(labRaw)

      const userData = store.getters['session/userData']()
      const profiles = userData?.laboratory_profiles || []
      const isValid = profiles.some(p => p.laboratory_slug === parsedLab.laboratory_slug)

      if (isValid) {
        store.commit('session/SET_LABORATORY', parsedLab)
        return next()
      }

      // Stale lab profile from a previous user — purge it
      localStorage.removeItem('user_lab_profile')
      sessionStorage.removeItem('user_lab_profile')
    } catch (e) {
      console.warn('No se pudo parsear user_lab_profile', e)
    }
  }

  if (to.path !== '/select-laboratory') {
    return next('/select-laboratory')
  }

  return next()
}
